<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <Filters @stepper="winStepper" @bookmarks="getBookmarks" />
    <Trending v-if="dataretrived && showComponent" v-bind:blogData="blogData" />
    <LatestFeeds v-if="dataretrived && showComponent" v-bind:blogData="blogData" />
    <FilterResult v-if="dataretrived2 && !showComponent" v-bind:blogData="blogData" />
  </div>
</template>

<script>
import axios from "axios";
import Filters from "./../Resources/Filters";
import Trending from "./../Resources/Trending";
import LatestFeeds from "./../Resources/LatestFeeds";
import FilterResult from "./../Resources/filterResult.vue";

export default {
  components: {
    Filters,
    Trending,
    LatestFeeds,
    FilterResult
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      ServerError: false,
      msg: null,
      dataretrived: false,
      blogData: null,
      showComponent: true,
      dataretrived2: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      if (localStorage.getItem("token")) {
        axios({
          method: "GET",
          url: "/blog/getdata",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          }
        })
          .then(response => {
            this.appLoading = false;
            this.blogData = response.data.data;
            this.dataretrived = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        axios({
          method: "GET",
          url: "/blog/getdata"
        })
          .then(response => {
            this.appLoading = false;
            this.blogData = response.data.data;
            this.dataretrived = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      }
    },
    winStepper(window_data) {
      this.showComponent = window_data.clearFilter;
      this.appLoading = true;
      var data = {};
      var cat = [];
      var cat2 = [];

      cat.push(window_data.category._id);
      cat2.push(window_data.category);
      data["category"] = cat;
      data["tag"] = window_data.tag;
      if (localStorage.getItem("token")) {
        axios({
          method: "POST",
          url: "/blog/getlist",
          data: data,
          headers: {
            "x-auth-token": localStorage.getItem("token")
          }
        })
          .then(response => {
            this.appLoading = false;
            this.blogData = response.data;
            this.blogData.window_data = cat2;
            this.dataretrived2 = true;
            this.dataretrived = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        axios({
          method: "POST",
          url: "/blog/getlist",
          data: data
          // headers: {
          //   "x-auth-token": localStorage.getItem("token")
          // }
        })
          .then(response => {
            this.appLoading = false;
            this.blogData = response.data;
            this.blogData.window_data = cat2;
            this.dataretrived2 = true;
            this.dataretrived = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      }
    },
    getBookmarks() {
      this.showComponent = false;
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/blog/mybookmarks",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.blogData = response.data.data;
          this.blogData.window_data = [{ name: "Bookmarks" }];
          this.dataretrived2 = true;
          this.dataretrived = true;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
